import styled from "styled-components";

export const ErrorModalOverlay = styled.div`
  position: fixed;
  z-index: 3000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(31, 41, 55, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorModalBox = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.15);
  padding: 24px 32px;
  min-width: 320px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ErrorModalClose = styled.span`
  cursor: pointer;
  font-weight: bold;
  font-size: 24px;
  margin-left: 12px;
  color: #B91C1C;
  line-height: 1;
  user-select: none;
`;

export const ErrorIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const InlineErrorBox = styled.div`
  background: #fee2e2;
  border-radius: 8px;
  color: #b91c1c;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin: 12px 0;
  font-size: 16px;
`;
